export default "__VITE_ASSET__Zn1qhSiS__"